import { render, staticRenderFns } from "./Education.vue?vue&type=template&id=4903cd54&scoped=true"
import script from "./Education.vue?vue&type=script&lang=js"
export * from "./Education.vue?vue&type=script&lang=js"
import style0 from "./Education.vue?vue&type=style&index=0&id=4903cd54&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4903cd54",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3029718028/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4903cd54')) {
      api.createRecord('4903cd54', component.options)
    } else {
      api.reload('4903cd54', component.options)
    }
    module.hot.accept("./Education.vue?vue&type=template&id=4903cd54&scoped=true", function () {
      api.rerender('4903cd54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/lifehikes/user/components/Education.vue"
export default component.exports